import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Header
      home: 'Home',
      introducing: 'Introducing',
      features: 'Features',
      gods: 'Gods',
      roadmap: 'Roadmap',
      language: 'Language',
      
      // Hero Section
      heroTitle: 'Welcome to TITAN\'S TAP',
      heroSubtitle: 'The Ultimate Blockchain Gaming Experience',
      playNow: 'Play Now',
      
      // Introducing Section
      introducingTitle: 'Introducing TITAN\'S TAP',
      introducingText1: 'TITAN\'S TAP is an innovative blockchain-based gaming platform. We combine traditional gaming with blockchain technology to provide a new gaming experience.',
      introducingText2: 'Players can convert in-game assets into real value and experience a fair and transparent gaming environment in a decentralized ecosystem.',
      introducingText3: 'TITAN\'S TAP goes beyond being just a gaming platform, building a community-centered ecosystem that presents a new gaming paradigm where all participants can grow together.',
      
      // Key Features Section
      featuresTitle: 'Key Features',
      security: 'Security',
      securityDesc: 'Secure asset management using the latest blockchain technology',
      gameplay: 'Gameplay',
      gameplayDesc: 'Various game modes and exciting gameplay experience',
      monetization: 'Monetization',
      monetizationDesc: 'Conversion of in-game assets into real value and revenue generation',
      community: 'Community',
      communityDesc: 'Active community activities and continuous updates',
      accessibility: 'Accessibility',
      accessibilityDesc: 'Mobile and desktop platform support',
      performance: 'Performance',
      performanceDesc: 'Optimized game engine and fast transaction processing',
      
      // Gods Section
      godsTitle: 'Meet the Gods',
      zeus: 'Zeus',
      zeusTitle: 'God of the Sky',
      zeusDesc: 'The god of the sky and lightning, king of all gods. His power can control the sky and wield lightning.',
      poseidon: 'Poseidon',
      poseidonTitle: 'God of the Sea',
      poseidonDesc: 'The god of the sea and earthquakes. His trident can control the sea and cause earthquakes.',
      hades: 'Hades',
      hadesTitle: 'God of the Underworld',
      hadesDesc: 'The ruler of the underworld, managing the souls of the dead and ruling the underworld.',
      athena: 'Athena',
      athenaTitle: 'Goddess of Wisdom',
      athenaDesc: 'The goddess of war and wisdom, symbolizing strategy and wisdom, bringing victory in war.',
      
      // Roadmap Section
      roadmapTitle: 'Road Map',
      q1_2024: '2024 Q1',
      projectStart: 'Project Start',
      projectStartDesc: 'Planning and development of TITAN\'S TAP project',
      q2_2024: '2024 Q2',
      alphaTest: 'Alpha Test',
      alphaTestDesc: 'Testing of initial version of the game and feedback collection',
      q3_2024: '2024 Q3',
      betaRelease: 'Beta Release',
      betaReleaseDesc: 'Public beta testing and community building',
      q4_2024: '2024 Q4',
      officialRelease: 'Official Release',
      officialReleaseDesc: 'Official release of TITAN\'S TAP and marketing campaign',
      q1_2025: '2025 Q1',
      communityExpansion: 'Community Expansion',
      communityExpansionDesc: 'New game modes and features addition'
    }
  },
  ko: {
    translation: {
      // Header
      home: '홈',
      introducing: '소개',
      features: '특징',
      gods: '신들',
      roadmap: '로드맵',
      language: '언어',
      
      // Hero Section
      heroTitle: 'TITAN\'S TAP에 오신 것을 환영합니다',
      heroSubtitle: '궁극의 블록체인 게임 경험',
      playNow: '지금 플레이',
      
      // Introducing Section
      introducingTitle: 'TITAN\'S TAP 소개',
      introducingText1: 'TITAN\'S TAP은 혁신적인 블록체인 기반의 게임 플랫폼입니다. 우리는 전통적인 게임과 블록체인 기술을 결합하여 새로운 게임 경험을 제공합니다.',
      introducingText2: '플레이어들은 게임 내에서 얻은 자산을 실제 가치로 변환할 수 있으며, 탈중앙화된 생태계에서 공정하고 투명한 게임 환경을 경험할 수 있습니다.',
      introducingText3: 'TITAN\'S TAP은 단순한 게임 플랫폼을 넘어, 커뮤니티 중심의 생태계를 구축하여 모든 참여자들이 함께 성장할 수 있는 새로운 게임 패러다임을 제시합니다.',
      
      // Key Features Section
      featuresTitle: '주요 특징',
      security: '보안',
      securityDesc: '최신 블록체인 기술을 활용한 안전한 자산 관리',
      gameplay: '게임플레이',
      gameplayDesc: '다양한 게임 모드와 흥미로운 게임플레이 경험',
      monetization: '수익화',
      monetizationDesc: '게임 내 자산의 실제 가치 변환 및 수익 창출',
      community: '커뮤니티',
      communityDesc: '활발한 커뮤니티 활동과 지속적인 업데이트',
      accessibility: '접근성',
      accessibilityDesc: '모바일 및 데스크톱 플랫폼 지원',
      performance: '성능',
      performanceDesc: '최적화된 게임 엔진과 빠른 트랜잭션 처리',
      
      // Gods Section
      godsTitle: '신들을 만나보세요',
      zeus: '제우스',
      zeusTitle: '천공의 신',
      zeusDesc: '천공과 번개의 신으로, 모든 신들의 왕입니다. 그의 힘은 하늘을 지배하고 번개를 다룰 수 있습니다.',
      poseidon: '포세이돈',
      poseidonTitle: '바다의 신',
      poseidonDesc: '바다와 지진의 신으로, 그의 삼지창은 바다를 통제하고 지진을 일으킬 수 있습니다.',
      hades: '하데스',
      hadesTitle: '명계의 신',
      hadesDesc: '명계의 통치자로, 죽은 자들의 영혼을 관리하고 지하세계를 다스립니다.',
      athena: '아테나',
      athenaTitle: '지혜의 여신',
      athenaDesc: '전쟁과 지혜의 여신으로, 전략과 지혜를 상징하며 전쟁에서 승리를 가져옵니다.',
      
      // Roadmap Section
      roadmapTitle: '로드맵',
      q1_2024: '2024년 1분기',
      projectStart: '프로젝트 시작',
      projectStartDesc: 'TITAN\'S TAP 프로젝트의 기획 및 개발 시작',
      q2_2024: '2024년 2분기',
      alphaTest: '알파 테스트',
      alphaTestDesc: '초기 버전의 게임 테스트 및 피드백 수집',
      q3_2024: '2024년 3분기',
      betaRelease: '베타 출시',
      betaReleaseDesc: '공개 베타 테스트 및 커뮤니티 구축',
      q4_2024: '2024년 4분기',
      officialRelease: '정식 출시',
      officialReleaseDesc: 'TITAN\'S TAP의 정식 출시 및 마케팅 캠페인',
      q1_2025: '2025년 1분기',
      communityExpansion: '커뮤니티 확장',
      communityExpansionDesc: '새로운 게임 모드 및 기능 추가'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ko',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 